export function transformToCartItem(data) {
    const cart_item = Object.assign({}, data);
    if (data.date_added) {
        cart_item.date_added = new Date(data.date_added);
    }
    return cart_item;
}
